import { Component, Inject, ViewChild } from '@angular/core';
import { AbbModalComponent } from '@components/abb-modal/abb-modal.component';
import { MODAL_DATA, ModalData } from '@components/abb-modal/modal';
import { AbbCommonModule } from 'app/abb-common.module';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';

export type AbbAlertData = {
  title?: string;
  message: string;
  htmlMessage?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onDispose?: () => void;
  cancelText?: string;
  confirmText?: string;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
  showCancelButtonRed?: boolean;
};

@Component({
  selector: 'abb-alert',
  standalone: true,
  imports: [AbbCommonModule, AbbModalComponent, TPipe],
  template: `
    <abb-modal
      #modalRef
      [onClose]="data.onCancel"
      [onDispose]="data.onDispose"
      [title]="data.title ?? ('Are you sure?' | t)"
    >
      @if(data.htmlMessage ?? false){
      <div [innerHTML]="data.message"></div>
      } @else {
      {{ data.message }}
      }
      <div footer class="justify-end flex gap-8">
        @if(data.showCancelButton ?? true){
        <abb-button variant="clean" (onclick)="onCancel()">
          {{ data.cancelText ?? ('cancel' | t) }}
        </abb-button>
        }
        @if(data.showConfirmButton ?? true){
        <abb-button (onclick)="onConfirm()">
          {{ data.confirmText ?? ('Confirm' | t) }}
        </abb-button>
        }
          @if(data.showCancelButtonRed ?? false){
        <abb-button (onclick)="onCancel()">
          {{ data.cancelText ?? ('Cancel' | t) }}
        </abb-button>
        }
      </div>
    </abb-modal>
  `,
  styles: ``,
  providers: [{ provide: TRANSLATION_PREFIX, useValue: 'commons' }],
})
export class AbbAlertComponent implements ModalData<AbbAlertData> {
  @ViewChild('modalRef') modalRef: AbbModalComponent | undefined;
  constructor(@Inject(MODAL_DATA) public data: AbbAlertData) {}

  onCancel() {
    this.data.onCancel();
    this.modalRef?.dispose();
  }
  onConfirm() {
    this.data.onConfirm();
    this.modalRef?.dispose();
  }
}
